<template>
  <div>
    <div class="title-dialog">
      <span>{{ langByLanguage.account_change_password }}</span>
    </div>
    <div class="item-line">
      <span>{{ langByLanguage.account_change_password_old }}<span class="cl-red">*</span></span>
      <el-input
        v-model="modelData.old_password"
        size="medium"
        show-password
      ></el-input>
    </div>
    <div class="item-line">
      <span>{{ langByLanguage.account_change_password_new }}<span class="cl-red">*</span></span>
      <el-input
        v-model="modelData.password"
        size="medium"
        show-password
      ></el-input>
    </div>
    <div class="item-line">
      <span>{{ langByLanguage.account_change_password_new_enter }}<span class="cl-red">*</span></span>
      <el-input
        v-model="modelData.password_confirm"
        size="medium"
        show-password
      ></el-input>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <el-button type="primary" plain @click="cancel()">{{ langByLanguage.action_cancel }}</el-button>
      <el-button
        type="primary"
        @click="submitChange()"
        :disable="!canSubmit"
        :loading="!canSubmit"
      >{{ langByLanguage.action_ok }}</el-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ls from "local-storage";
import { mapGetters } from "vuex";

export default {
  name: "ChangePassword",
  metaInfo() {
    return {
      title: "",
    };
  },
  components: {},
  data() {
    return {
      canSubmit: true,
      modelData: {
        old_password: "",
        password: "",
        password_confirm: "",
      },

    };
  },
  computed: {
    ...mapGetters(["langByLanguage"]),
  },
  mounted() {},
  methods: {
    cancel (){
      this.modelData = {
        password: "",
        old_password: "",
        password_confirm: "",
      };
      this.$emit("cancelChange", true);
    },
    async submitChange () {
      if (!this.modelData.old_password) {
        this.$notify.warning({
          title: "Cảnh báo",
          message: "Vui lòng nhập mật khẩu cũ",
        });
        return;
      }
      if (!this.modelData.password) {
        this.$notify.warning({
          title: "Cảnh báo",
          message: "Vui lòng nhập mật khẩu mới",
        });
        return;
      }
      if (this.modelData.password != this.modelData.password_confirm) {
        this.$notify.warning({
          title: "Cảnh báo",
          message: "Xác nhận mật khẩu mới không khớp",
        });
        return;
      }
      let  data = this.modelData
      this.canSubmit = false;
      await axios.post("auth/change-password", data).then((response) => {
        this.canSubmit = true;
        switch (response.data.code) {
          case 200:
            this.$notify({
              message: "Đổi mật khẩu thành công",
              type: "success",
            });
            this.$router.push({ name: "account-login" });
            this.modelData = {
              password: "",
              old_password: "",
              password_confirm: "",
            };
            this.$emit("cancelChange", true);
            var token = ls.get("token", "");
            if (token) {
              ls.remove("token");
            }
            location.reload();
            break;
          case 422:
            this.$notify({
              title: "Có lỗi xảy ra",
              message: Object.values(response.data)[0],
              type: "warning",
            });
            break;
          default:
            this.$notify.error({
              title: "Error",
              message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
            });
            break;
        }
      });

    }
  },
  watch: {},
};
</script>

<style lang="css" scoped>
.cl-red {
  color: red;
}
</style>
